(()=>{'use strict';
const signature=line=>JSON.stringify([Number(line.variant_id??line.id),Object.entries(line.properties||{}).sort(([a],[b])=>a.localeCompare(b))]);
const managed=line=>line.properties?._color_builder==='v1';
const bundleCodeValid=code=>typeof code==='string'&&/^COLOR-[A-Z0-9_-]{1,180}$/i.test(code);
function createBundleResolver({getApp,timeoutMs=15000}){
 return ()=>new Promise((resolve,reject)=>{
  const app=getApp();
  if(typeof app?.getCheckoutInfo!=='function'){reject(Error('bundle_unavailable'));return}
  let settled=false;
  const finish=(error,code)=>{if(settled)return;settled=true;clearTimeout(timer);error?reject(error):resolve(code)};
  const timer=setTimeout(()=>finish(Error('bundle_unavailable')),timeoutMs);
  try{app.getCheckoutInfo(data=>{
   if(data?.status_code!==200||data.can_apply_discount!==true||!bundleCodeValid(data.code)){finish(Error('bundle_unavailable'));return}
   finish(null,data.code);
  })}catch{finish(Error('bundle_unavailable'))}
 });
}
function create({request,planner,getBundleCode}){
 let pending=false;
 const read=()=>request('cart.js');
 async function sync(plan){
  if(pending)throw Error('cart_busy');
  if(!plan||!Array.isArray(plan.items)||!['none','welcome','bundle','gift'].includes(plan.discountMode))throw Error('invalid_plan');
  if(typeof plan.code!=='string'||plan.code.trim().toUpperCase()==='OGEN20')throw Error('pickup_coupon_unavailable');
  pending=true;
  try{
   let cart=await read();
   if(!Array.isArray(cart.items)||cart.currency!=='ILS')throw Error('invalid_cart');
   if(cart.items.some(line=>!managed(line)))throw Error('cart_other_items');
   const expected=new Map(plan.items.map(line=>[signature(line),line]));
   const found=new Set(cart.items.map(signature));
   for(const s of found){
    const target=expected.get(s)?.quantity||0;
    for(let attempt=0;attempt<=cart.items.length+1;attempt++){
     const current=await read();
     if(!Array.isArray(current.items)||current.items.some(line=>!managed(line)))throw Error('cart_other_items');
     const matches=current.items.filter(line=>signature(line)===s),quantity=matches.reduce((n,line)=>n+line.quantity,0);
     if(quantity===target)break;
     const line=quantity>target?matches[matches.length-1]:matches[0];
     if(!line?.key)throw Error('invalid_cart');
     const next=Math.max(0,line.quantity+target-quantity);
     await request('cart/change.js',{id:line.key,quantity:next});
     const updated=await read(),actual=updated.items?.filter(line=>signature(line)===s).reduce((n,line)=>n+line.quantity,0);
     if(actual!==quantity+next-line.quantity)throw Error('cart_stock_error');
     if(actual===target)break;
     if(attempt===cart.items.length+1)throw Error('invalid_cart');
    }
   }
   const missing=plan.items.filter(line=>!found.has(signature(line)));
   if(missing.length)await request('cart/add.js',{items:missing});
   let code=plan.code||'';
   if(plan.discountMode==='bundle'){
    if(typeof getBundleCode!=='function')throw Error('bundle_unavailable');
    await request('cart/update.js',{discount:''});
    code=await getBundleCode();
    if(!bundleCodeValid(code))throw Error('bundle_unavailable');
   }
   await request('cart/update.js',{discount:code});
   cart=await read();
   const activeCodes=(cart.discount_codes||[]).filter(c=>c.applicable!==false);
   if(activeCodes.some(c=>typeof c.code!=='string'||c.code.toUpperCase()!==code.toUpperCase()))throw Object.assign(Error('discount_conflict'),{cart});
   if(code&&(!Array.isArray(cart.discount_codes)||!cart.discount_codes.some(c=>typeof c.code==='string'&&c.code.toUpperCase()===code.toUpperCase()&&c.applicable===true)))throw Object.assign(Error(plan.discountMode==='welcome'?'coupon_ineligible':'bundle_unavailable'),{cart});
   const result=planner.reconcile(plan,cart);
   if(!result.ok)throw Object.assign(Error(result.reason),{cart});
   return cart;
  }catch(error){
   if(!error.cart)try{error.cart=await read()}catch{}
   throw error;
  }finally{pending=false}
 }
 return {read,sync,isPending:()=>pending};
}
function nativeRequest(rootURL,fetcher){
 const root=new URL(rootURL,window.location.origin);
 if(root.origin!==window.location.origin)throw Error('invalid_route');
 if(!root.pathname.endsWith('/'))root.pathname+='/';
 return async(endpoint,body)=>{
  if(!['cart.js','cart/add.js','cart/update.js','cart/change.js'].includes(endpoint))throw Error('invalid_route');
  const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),15000);
  let status=null,mime='missing',phase='fetch';
  const diagnose=(event,code)=>{try{if(typeof console!=='undefined'&&typeof console.warn==='function')console.warn('[COLOR cart] '+JSON.stringify({event,endpoint,status,mime,...(code?{code}:{})}))}catch{}};
  try{
   const response=await fetcher(new URL(endpoint,root).href,{method:body?'POST':'GET',credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{}),signal:controller.signal});
   status=Number.isInteger(response.status)&&response.status>=100&&response.status<=599?response.status:null;
   const type=(response.headers.get('content-type')||'').split(';')[0].trim().toLowerCase();
   mime=['application/json','text/html','text/plain','application/javascript','text/javascript','application/octet-stream'].includes(type)?type:type?'other':'missing';
   phase='mime';
   if(!['application/json','text/javascript','application/javascript'].includes(type))throw Error('cart_unavailable');
   phase='json';
   const result=await response.json();
   phase='http';
   if(!response.ok)throw Error(response.status===422?'cart_stock_error':'cart_unavailable');
   return result;
  }catch(error){diagnose('request_failed',error?.name==='AbortError'?'cart_request_uncertain':phase==='fetch'?'fetch_rejected':phase==='mime'?'non_json_response':phase==='json'?'invalid_json':status===422?'cart_stock_error':'cart_unavailable');if(error.name==='AbortError')throw Error('cart_request_uncertain');throw error}finally{clearTimeout(timer)}
 };
}
const api={create,nativeRequest,signature,managed,createBundleResolver,bundleCodeValid};
if(typeof module!=='undefined'&&module.exports)module.exports=api;
if(typeof window!=='undefined')window.COLOR_CART_TRANSPORT=api;
})();
